(function () {
  if (typeof Swiper === 'undefined') return;

  function initGroup(swiperSelector, wrapperClass, slideClass, nextClass, prevClass, sectionSelector) {
    document.querySelectorAll(swiperSelector).forEach(function (el) {
      if (el.classList.contains('swiper-initialized')) return;

      var scope = el.closest(sectionSelector) || document;

      new Swiper(el, {
        wrapperClass: wrapperClass,
        slideClass: slideClass,
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: Array.from(scope.querySelectorAll(nextClass)),
          prevEl: Array.from(scope.querySelectorAll(prevClass)),
          disabledClass: 'disabled',
        },
      });
    });
  }

  initGroup('.cozy-corporate--swiper', 'cozy-corporate--swiper--wrapper', 'cozy-corporate--block', '.cozy-corporate--next', '.cozy-corporate--prev', '.cozy-corporate');
  initGroup('.cozy-personal--swiper', 'cozy-personal--swiper--wrapper', 'cozy-personal--block', '.cozy-personal--next', '.cozy-personal--prev', '.cozy-personal');

  function equalizeTitles(wrapperSelector, titleSelector) {
    document.querySelectorAll(wrapperSelector).forEach(function (wrapper) {
      var titles = wrapper.querySelectorAll(titleSelector);
      if (!titles.length) return;

      titles.forEach(function (title) {
        title.style.minHeight = '';
      });

      var maxHeight = 0;
      titles.forEach(function (title) {
        maxHeight = Math.max(maxHeight, title.offsetHeight);
      });

      titles.forEach(function (title) {
        title.style.minHeight = maxHeight + 'px';
      });
    });
  }

  function equalizeAll() {
    equalizeTitles('.cozy-corporate--swiper--wrapper', '.cozy-corporate--block--title');
    equalizeTitles('.cozy-personal--swiper--wrapper', '.cozy-personal--block--title');
  }

  equalizeAll();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(equalizeAll);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeAll, 200);
  });
})();
